import React, { useState, useEffect } from 'react';
import axios from "axios";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Container,
} from "reactstrap";

import {
    Modal,
    Fade,
    Backdrop
} from "@material-ui/core";

// Charts
import StanfordChart from '../../variables/StanfordChart';

// Date Range Picker
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { ko } from 'date-fns/locale'

import { addDays } from 'date-fns';

import { useTranslation } from 'react-i18next';

// Loader
import Loader from "react-spinner-loader";

let dataType = "";
const ChartType_stanford = "stanford";
const ChartType_line = "line";
export default function LSIM_PEPL(props) {
    const { t, i18n } = useTranslation();

    // Chart
    const [modalIsOpen, setIsOpen] = React.useState(false); //MODAL
    
    const [errors, setErrors] = React.useState([]);
    const [chartData, setChartData] = React.useState(); // Chart data
    const [isLoading, setIsLoading] = useState(false);
    const [calendarPick, setcalendarPick] = useState([ //달력 picker
        {
            startDate: new Date(),
            endDate: addDays(new Date(), 7),
            key: 'selection'
        }
    ]);
    // 새로고침 관련 상태
    const [isRefreshing, setIsRefreshing] = useState(false);


    


    function openModal(ChartType) {
        //alert(ChartType);
        dataType = ChartType;
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    async function dateQuery(startDate, endDate, chartType) {
        //UTC+9에서 UTC+0변환
        //const formattedDate = utcDate.slice(0, 4) + utcDate.slice(5, 7) + utcDate.slice(8, 10);
        //const formattedDate = date.toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\./g, '');
        setIsLoading(true);

        //같은날짜면 0
        const dateDifference = (endDate - startDate) / (1000 * 60 * 60 * 24);
        //alert(dateDifference);

        //다른날짜면 1 이상
        // if (dateDifference >= 1 && (props.roleCheck != "admin")) {
        if ((props.roleCheck != "admin")) {
        
            // // alert("2일 이상 기간조회는 권한이 필요합니다.\n1일 단위로 선택해주세요");
            alert("권한이 필요합니다. 서비스 문의를 이용해주세요.");
            setIsLoading(false);
            return;
        }
        //한달 이상 조회 서버부하로 인해 금지
        if (dateDifference > 30) {
            alert("최대 1달까지 조회가 가능합니다.");
            setIsLoading(false);
            return;
        }
        //alert("dataQuery: " + startDate + '/' + endDate +  '/' + chartType);
        //시작일~ 종료일 YYYY-MM-DD 포맷 변경
        startDate = startDate.toLocaleDateString().replace(/\./g, '').split(' ').map((v, i) => i > 0 && v.length < 2 ? '0' + v : v).join('-');
        endDate = endDate.toLocaleDateString().replace(/\./g, '').split(' ').map((v, i) => i > 0 && v.length < 2 ? '0' + v : v).join('-');

        //alert(startDate+","+endDate+","+chartType);
        //console.log(startDate + '/' + endDate + '/' + chartType);

        let LSIMquery;
        try {
            LSIMquery = await axios.post(
                `/con_lsim`,
                {
                    startDate: startDate,
                    endDate: endDate,
                    chartType: chartType,
                },
                { baseURL: process.env.REACT_APP_SERVER_URL },
                { withCredentials: true },
            );
        } catch ({ response }) {
            LSIMquery = response;
            alert(JSON.stringify(response));
            setIsLoading(false);
        }

        const { data: LSIMqueryData } = LSIMquery;

        if (LSIMqueryData.success) {
            //alert("access fail\n"+JSON.stringify(LSIMqueryData));
            setErrors(
                LSIMqueryData.messages && LSIMqueryData.messages.errors
            );
            setIsLoading(false);
        } else {
            const newChartData = Object.values(LSIMqueryData).map(e => {
                return { x: e.x, y: e.y, epochs: e.epochs };
            });
            setChartData(newChartData);
            setIsLoading(false);
        }
    }
    const handleRefreshClick = () => {
        if (isRefreshing) {
            // 새로고침 중지
            setIsRefreshing(false);
        } else {
            // 새로고침 시작
            setIsRefreshing(true);
            // "오늘" 버튼과 동일한 기능을 수행
            dateQuery(new Date(), new Date(), ChartType_stanford);
        }
    };
    // 새로고침 상태 변경에 따른 타이머 설정 및 해제
    useEffect(() => {
        let interval;
        if (isRefreshing) {
            interval = setInterval(() => {
                dateQuery(new Date(), new Date(), ChartType_stanford);
            }, 60000); // 1분마다 실행
        }
        return () => clearInterval(interval); // 컴포넌트가 언마운트되거나 새로고침이 중지될 때 타이머 해제
    }, [isRefreshing]);

    return (
        <div className="GraphContent">
            <div className="SearchContent">
                <div className="SearchArea">
                    {t('LoneSmart.Monitoring.QueryPeriod')} :
                    <Button
                        className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
                        onClick={() => {
                            dateQuery(new Date(), new Date(), ChartType_stanford)
                        }}>
                        {t('LoneSmart.Monitoring.Today')}
                    </Button>
                    <Button
                        className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
                        onClick={() => {
                            const endDate = new Date();
                            const startDate = new Date();
                            startDate.setDate(endDate.getDate() - 7);
                            dateQuery(startDate, endDate, ChartType_stanford);
                        }}
                    >
                        {t('LoneSmart.Monitoring.LastWeek')}
                    </Button>
                    <Button id="lineRange"
                        className={`selectBtn ${i18n.language && i18n.language.startsWith('en') ? 'selectBtn-en' : ''}`}
                        onClick={() => openModal(ChartType_stanford)}>
                        {t('LoneSmart.Monitoring.DateQuery')}
                    </Button>
                    {props.roleCheck === "admin" && (
                        <Button
                            className={`selectBtn ${i18n.language === 'en-US' ? 'selectBtn-en' : ''}`}
                            onClick={handleRefreshClick}
                        >
                            {isRefreshing ? t('LoneSmart.Monitoring.StopRefresh') : t('LoneSmart.Monitoring.StartRefresh')}
                        </Button>
                    )}
                </div>
            </div>
            {/* <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: '5px', display: 'inline-flex'}}> */}
            <div className="searchExampleText"><span style={{ color: '#0B1659' }}>{t('LoneSmart.Monitoring.SelectPeriodMessage')}</span></div>
            {/* </div> */}

            <div className="GraphArea" style={{ width: '50%', height: '50%' }}>
                {isLoading &&
                    // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                    <div className="loader">
                        <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                        </div>
                    </div>
                }
                
                <div style={{ margin: 'auto', position: 'relative', width: '100%', height: '100%', textAlign: 'center' }}>
                    <StanfordChart chartData={chartData} />
                </div>
                <Modal
                    open={modalIsOpen}
                    onClose={closeModal}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    // style={{ position: 'fixed', top: '30vh' }}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // 중앙 위치로 변경
                >
                    <Fade in={modalIsOpen}>
                        <div style={{ width: 'fit-content' }}>
                            <Container
                                style={{
                                    width: 'fit-content',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // alignItems: 'center',
                                    // justifyContent: 'center',
                                    margin: 'auto',
                                }}
                            >
                                <Card>
                                    <CardHeader>Calendar</CardHeader>
                                    <CardBody>
                                        <DateRangePicker
                                            locale={ko}
                                            onChange={item => setcalendarPick([item.selection])}
                                            showSelectionPreview={true}
                                            moveRangeOnFirstSelection={false}
                                            months={2}
                                            ranges={calendarPick}
                                            direction="horizontal"
                                            maxDate={addDays(new Date(), 0)}
                                        />
                                        <CardFooter>
                                            <Button className="modalBtn itsBtnDefault" onClick={() => {
                                                setIsOpen(false); dateQuery(calendarPick[0].startDate, calendarPick[0].endDate, dataType)
                                            }}>
                                                조회
                                            </Button>
                                            <Button className="modalBtn itsBtnGray" onClick={closeModal}>
                                                닫기
                                            </Button>
                                        </CardFooter>
                                    </CardBody>
                                </Card>
                            </Container>
                        </div>
                    </Fade>
                </Modal>
            </div>

        </div>

    )
};